import { h } from 'preact';

import { ArrowDown } from '@travel/icons/ui';
import { IconTextTag } from '@travel/ui';

import styles from './planSkeleton.module.scss';

type Props = {
  isPc: boolean;
  isFirst?: boolean;
};

const PlanSkeleton = (props: Props) => {
  const { isPc, isFirst } = props;
  return (
    <div class={styles.container}>
      <div class={styles.mediaSkeleton} />
      <div class={styles.planInformation}>
        <div class={styles.mainInformation}>
          <IconTextTag haveBorder isEmpty className={styles.tag} />
          {isPc && (
            <>
              <IconTextTag haveBorder isEmpty className={styles.tag} />
              <IconTextTag haveBorder isEmpty className={styles.tag} />
            </>
          )}
          <div class={styles.planSkeleton} />
        </div>
        {isPc && <div class={styles.pcImage} />}
      </div>
      {isFirst && (
        <div class={styles.planInformation}>
          <div class={styles.mainInformation}>
            <IconTextTag haveBorder isEmpty className={styles.tag} />
            {isPc && (
              <>
                <IconTextTag haveBorder isEmpty className={styles.tag} />
                <IconTextTag haveBorder isEmpty className={styles.tag} />
              </>
            )}
            <div class={styles.planSkeleton} />
          </div>
          {isPc && <div class={styles.pcImage} />}
        </div>
      )}
      {!isPc && (
        <div class={styles.planExpand}>
          <ArrowDown color="pastelGray" size={20} className={styles.iconArrow} />
        </div>
      )}
    </div>
  );
};

export default PlanSkeleton;
